import React from "react";
import { Chart, ArcElement } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import PropTypes from "prop-types";
import styled from "styled-components";

import UserSmileIcon from "../Icons/UserSmile";
import GridComponent from "../Styles/Grid";
import useWidthHook from "../Hooks/useWidth";
import CheckboxIcon from "../Icons/Checkbox";

Chart.register(ArcElement);

const propTypes = {
  title: PropTypes.string.isRequired,
  completed: PropTypes.arrayOf(PropTypes.string),
  list: PropTypes.arrayOf(PropTypes.object).isRequired
};

const defaultProps = {
  completed: [],
  list: []
};

const CheckList = ({ list, completed, title, className, ...props }) => {
  /**
   * hooks
   */
  const width = useWidthHook();

  /**
   * variables
   */
  const percentage =
    Number(Math.ceil((completed?.length / list?.length) * 100)) || 0;

  return (
    <Wrapper className={`rounded ${className || ""}`} {...props}>
      <div className="checklist__header">
        <UserSmileIcon
          width={146}
          height={146}
          color="var(--bs-primary-80)"
          className="position-absolute"
          style={{ left: "-4rem", top: "-1.25rem" }}
        />

        <GridComponent
          gaps={{ sm: "1.5rem" }}
          columns={{ sm: "minmax(0, 1fr) 3.5rem" }}
          className="align-items-center position-relative"
        >
          <div>
            <p className="fw-bold">{title}</p>
          </div>
          <div className="checklist__header__progress">
            <Doughnut
              data={{
                datasets: [
                  {
                    cutout: 22,
                    data: [percentage, 100 - percentage],
                    borderColor: "transparent",
                    backgroundColor: ["#fff", "#3b9e7a"]
                  }
                ]
              }}
            />
            <small className="position-absolute fw-medium">{percentage}%</small>
          </div>
        </GridComponent>
      </div>
      {width > 768 && Boolean(list?.length) && (
        <div className="checklist__body">
          <GridComponent gaps={{ sm: "2rem" }}>
            {list.map(({ name, slug }, key) => (
              <div
                key={key}
                className="d-flex align-items-center justify-content-between"
              >
                <small className="fw-bold">{name}</small>
                <CheckboxIcon
                  color="#fff"
                  variant="circle"
                  checkedColor="#fff"
                  checked={completed.includes(slug)}
                />
              </div>
            ))}
          </GridComponent>
        </div>
      )}
    </Wrapper>
  );
};

/**
 * Styles
 */
const Wrapper = styled.div`
  color: #fff;
  background-color: var(--bs-primary);

  .checklist {
    &__header,
    &__body {
      padding: 1rem;
      overflow: hidden;
      position: relative;
    }

    &__header__progress {
      width: 3.5rem;
      display: flex;
      height: 3.5rem;
      position: relative;
      align-items: center;
      justify-content: center;

      small {
        font-size: 0.75rem;
      }
    }
  }
`;

CheckList.propTypes = propTypes;
CheckList.defaultProps = defaultProps;

export default CheckList;
